var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general-padding",attrs:{"id":"order-view"}},[_c('h4',[_vm._v("Pedidos comenzados (en espera de pago)")]),_c('div',{staticClass:"order-list"},[_c('order-list',{attrs:{"orders":_vm.checkouts,"isCheckoutsPage":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }